export enum CommonErrors {
    requiredField = 'This field is required',
    emailFormat = 'Check Email format',
}
